import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import AnswerGrid from './answerGrid';
import { initQuestionList, getValueKey } from './utils';
import { useLang } from '../../../../util/lang';
import { useSelector } from 'react-redux';

const LABEL_SUFFIX_OPTIONS = ['pontic', 'ponticColor']; // options that need to add suffix (_v2) to the label
const RETAINER_DESIGN_QUESTIONS_FIELDS = [
    'clearRetainerDesignUpper',
    'clearRetainerDesignLower',
    'clearRetainerDesignUpperForSecondSet',
    'clearRetainerDesignLowerForSecondSet',
];

const ReadOnlyPrescription = ({ impressionType, prescription, isNewCase = false, isInSummary = false }) => {
    const getDiffRetainerLang = useLang('DiffRetainer');
    const diffRetainerReducer = useSelector((state) => state.diffRetainer);
    const { questions } = diffRetainerReducer;

    const questionList = useMemo(() => {
        if (!questions) return initQuestionList;
        return Object.entries(questions)
            .filter(([key, value]) => {
                const name = value?.name;
                return (
                    name !== 'archPosition' &&
                    name !== 'impressionOption' &&
                    name !== 'specialInstructions' &&
                    name !== 'pontics' &&
                    name !== 'clearRetainerDesignUpperForSecondSet' &&
                    name !== 'clearRetainerDesignLowerForSecondSet'
                );
            })
            .map(([key, value]) => {
                const question = value;
                const labelSuffix = LABEL_SUFFIX_OPTIONS.includes(question.name) ? '_v2' : '';
                let questionLabel = getDiffRetainerLang(`formQuestionLabel.${question.name}${labelSuffix}`);
                if (RETAINER_DESIGN_QUESTIONS_FIELDS.includes(question.name)) {
                    questionLabel = getDiffRetainerLang(`formQuestionLabel.retainerDesignQuestion`);
                }

                return {
                    question: questionLabel,
                    field: question.name,
                };
            });
    }, [questions, getDiffRetainerLang]);

    const key = useMemo(() => {
        if (!prescription) return '';
        return `${impressionType}`;
    }, [prescription]);

    const title = useMemo(() => {
        const Wrapper = isNewCase ? 'h4' : 'h3';
        const impressionTypeDisplay = getDiffRetainerLang(`formOptions.${impressionType}`);
        const retainerTypeDisplay = getDiffRetainerLang(`readOnlyPrescription.retainerType`);
        return (
            <Wrapper>
                {impressionTypeDisplay} - {retainerTypeDisplay}
            </Wrapper>
        );
    }, [isNewCase, impressionType]);

    const direction = useMemo(() => {
        return isNewCase ? 'row' : 'column';
    }, [isNewCase]);

    return (
        <Grid container direction={direction} spacing={2}>
            <Grid item xs={12}>
                {title}
            </Grid>
            <ol>
                {questionList.map((question) => {
                    const vKey = getValueKey(question.field);
                    const valueKey = `${key}${vKey}`;
                    const isValueArray = Array.isArray(prescription[valueKey]);
                    let isInvalid =
                        prescription[valueKey] === null ||
                        prescription[valueKey] === undefined ||
                        prescription[valueKey] === '';
                    if (isValueArray) {
                        isInvalid = !prescription[valueKey].length;
                    }
                    if (isInvalid) return null;
                    return (
                        <li>
                            <Grid>
                                <Grid style={{ margin: '8px 18px' }} item key={question.field}>
                                    <p style={{ color: isInvalid ? 'lightgray' : 'black' }}>{question.question}</p>
                                </Grid>
                                <section style={{ margin: '8px 18px' }}>
                                    <AnswerGrid
                                        field={vKey}
                                        value={prescription[valueKey]}
                                        isInSummary={isInSummary}
                                        prescription={prescription}
                                        impressionType={impressionType}
                                    />
                                </section>
                            </Grid>
                        </li>
                    );
                })}
            </ol>
        </Grid>
    );
};

export default ReadOnlyPrescription;
